<template>
  <div>
    <!-- DASHBOARD -->
    <PageHeader :title="title" :items="items" />
    <div>
      <b-card no-body>
        <b-card-body>
          <b-card-title>
            <h5 class="card-title">Consultar</h5>
          </b-card-title>

          <div class="row">
            <b-form-group
              label="Período"
              invalid-feedback="campo obrigatório"
              class="col-md-3"
              :state="state('referencia')"
            >
              <date-picker
                v-model="dados.referencia"
                range
                append-to-body
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                placeholder="Intervalo"
              ></date-picker>
            </b-form-group>
            <b-form-group
              label="Contrato Serviço"
              invalid-feedback="campo obrigatório"
              class="col-md-2"
              :state="state('contrato')"
            >
              <multiselect
                v-model="dados.contrato"
                placeholder="Selecione"
                :show-labels="false"
                :options="optionContrato"
                label="nome"
                :allow-empty="false"
                @input="inputContrato"
              />
            </b-form-group>

            <b-form-group
              label="Projeto"
              invalid-feedback="campo obrigatório"
              class="col-md-3"
              :state="state('projeto')"
            >
              <multiselect
                v-model="dados.projeto"
                placeholder="Selecione"
                :show-labels="false"
                :options="optionProjeto"
                label="nome"
                :allow-empty="false"
                @input="inputProjeto"
              />
            </b-form-group>

            <b-form-group
              label="Cooperado"
              invalid-feedback="campo obrigatório"
              class="col-md-4"
            >
              <multiselect
                v-model="dados.cooperado"
                placeholder="Selecione"
                :show-labels="false"
                :options="optionCooperado"
                label="nome"
                :allow-empty="true"
              />
            </b-form-group>
          </div>
          <div class="row">
            <div class="d-flex justify-content-end px-1">
              <div class="me-2 align-self-center mt-1">
                <b-button variant="primary" @click="filtrar()" class="m-1">
                  <i class="mdi mdi-filter-outline font-size-16 align-middle me-2"></i>
                  Filtrar
                </b-button>
              </div>
              <div div class="me-2 align-self-center mt-1">
                <b-button @click="limparFormulario()">
                  <i class="mdi mdi-broom font-size-16
                      align-middle me-2"></i>
                  Limpar
                </b-button>
              </div>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </div>

    <div class="row">
      <div class="col-md-4">
        <b-card>
          <b-card-title>
            <h5 class="card-title">Mapa</h5>
          </b-card-title>

          <div id="map" style="height: 600px"></div>

          <b-form-group
            invalid-feedback="campo obrigatório"
            class="mt-2"
            :state="state('contrato')"
          >
          <div class="d-flex">
            <b-button @click="trataData('atrasa')" variant="primary" class="py-0">                   
              <i class="mdi mdi-arrow-left-bold font-size-20"></i> 
            </b-button>
            <date-picker
            class="mx-2"
              v-model="mapaCalendario"
              type="date"
              placeholder="dd/mm/aaaa"
              format="DD/MM/YYYY"
              @input="montarMapaCalor"
            ></date-picker>
            <b-button @click="trataData('avanca')" variant="primary" class="py-0">                   
              <i class="mdi mdi-arrow-right-bold font-size-20"></i> 
            </b-button>
          </div>

          </b-form-group>
        </b-card>
      </div>

      <div class="col-md-8">
        <div class="d-flex justify-content-center" v-if="loading">
          <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
        </div>
        <b-card v-if="viewVeiculos">
          <b-card-title>
            <h5 class="card-title">Indicadores e Ocorrências</h5>
          </b-card-title>
          <div class="row">
            <div class="col-md-3">
              <div @click="tableAcoes('placa')"
                class="card shadow-none border div-clickable"
                :class="fundoBotao('placa')"
              >
                <div class="card-body p-3">
                  <div>
                    <h1 class="text-center text-blue">{{dashboard.placa.quantidade}}</h1>
                  </div>
                </div>
                <h6 class="text-center">Total Veículos</h6>
              </div>
            </div>

            <div class="col-md-3">
              <div @click="tableAcoes('cooperados')"
                class="card shadow-none border div-clickable"
                :class="fundoBotao('cooperados')"
              >
                <div class="card-body p-3">
                  <div>
                    <h1 class="text-center text-blue">{{dashboard.cooperados.quantidade}}</h1>
                  </div>
                </div>
                <h6 class="text-center">Nº Cooperados</h6>
              </div>
            </div>

            <div class="col-md-3">
              <div class="card shadow-none border">
                <div class="card-body p-3">
                  <div>
                    <h1 class="text-center text-blue">0</h1>
                  </div>
                </div>
                <h6 class="text-center">Não Rastreados</h6>
              </div>
            </div>

            <div class="col-md-3">
              <div @click="tableAcoes('maiorVelocidade')"
                class="card shadow-none border div-clickable"
                :class="fundoBotao('maiorVelocidade')"
              >
                <div class="card-body p-3">
                  <div>
                    <h1 class="text-center text-blue">{{dashboard.maiorVelocidade.quantidade}}</h1>
                  </div>
                </div>
                <h6 class="text-center">Maior Velocidade</h6>
              </div>
            </div>

            <div class="col-md-3">
              <div @click="tableAcoes('excessoVelocidade')"
                class="card shadow-none border div-clickable"
                :class="fundoBotao('excessoVelocidade')"
              >
                <div class="card-body p-3">
                  <div>
                    <h1 class="text-center text-blue">{{dashboard.excessoVelocidade.cooperado.length}}</h1>
                  </div>
                </div>
                <h6 class="text-center">Excesso de Velocidade</h6>
              </div>
            </div>

            <div class="col-md-3">
              <div @click="tableAcoes('foraHorario')"
                class="card shadow-none border div-clickable"
                :class="fundoBotao('foraHorario')"
              >
                <div class="card-body p-3">
                  <div>
                    <h1 class="text-center text-blue">{{dashboard.foraHorario.cooperado.length}}</h1>
                  </div>
                </div>
                <h6 class="text-center">Uso Fora de Horário</h6>
              </div>
            </div>

            <div class="col-md-3">
              <div @click="tableAcoes('madrugada')"
                class="card shadow-none border div-clickable"
                :class="fundoBotao('madrugada')"
              >
                <div class="card-body p-3">
                  <div>
                    <h1 class="text-center text-blue">{{dashboard.madrugada.cooperado.length}}</h1>
                  </div>
                </div>
                <h6 class="text-center">Uso na Madrugada</h6>
              </div>
            </div>

            <div class="col-md-3">
              <div @click="tableAcoes('risco')"
                class="card shadow-none border div-clickable"
                :class="fundoBotao('risco')"
              >
                <div class="card-body p-3">
                  <div>
                    <h1 class="text-center text-blue">{{dashboard.risco.cooperado.length}}</h1>
                  </div>
                </div>
                <h6 class="text-center">Condução de Risco</h6>
              </div>
            </div>
          </div>
        </b-card>
        <b-card class="table-responsive" v-if="viewTabela">
          <b-table
            responsive="sm"
            :items="itemsTable"
            :per-page="perPage"
            :current-page="currentPage"
          >
            <template v-slot:cell(detalhes)="data">
              <div>
                <b-button variant="primary"
                          @click="detalhes(data.item)">
                  <i class="mdi mdi-send"></i>
                </b-button>
              </div>
            </template>
          </b-table>
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </b-card>
     
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      title: "Dashboard | Telemetria de Veículos",
      items: [
        {
          text: "Telemetria",
        },
        {
          text: "Dashboard"
        }
      ],
      viewVeiculos: false,
      viewTabela: false,
      map: {},
      heatmap: null,
      google: {},
      submit: false,
      loading: false,
      filtro: [],
      campos: [
        {
          key: "nm_cooperado",
          label: "Cooperado",
          sortable: true,
        },
        {
          key: "nm_projeto",
          label: "Projeto",
          sortable: true,
        },
        {
          key: "nm_placa",
          label: "Placa",
        },
        {
          key: "nm_tipo",
          label: "Tipo",
          sortable: true,
        },
        {
          key: "nm_rastreio",
          label: "Rastreio?",
          sortable: true,
        },
      ],
      itemsTable: [],
      acao:"",
      dados: {
        contrato: null,
        matriz: null,
        projeto: null,
        cooperado: null,
        referencia: null,
      },
      optionContrato: [],
      optionProjeto: [],
      optionCooperado: [],
      mapsAux: "",
      rows: 0,
      dadosGps:[],
      dashboard: {},
      mapaCalendario:"",
      defaultCalendario:false,
      currentPage: 1,
      perPage: 10,
    };
  },

  validations: {
    dados: {
      referencia: {
        required,
      },
      contrato: {
        required,
      },
      projeto: {
        required,
      },
    },
  },

  created() {
    this.$store
      .dispatch("filtroTomador", this.$store.state.filtroTomador)
      .then((response) => {
        this.optionContrato = this.$tools.filtroTomador.selectContratos(response)
      });
  },

  async mounted() {
    try {
      this.google = await this.$gmaps();
      this.map = new this.google.maps.Map(document.getElementById("map"), {
        center: { lat: -23.469806037053726, lng: -51.81222191718324 },
        zoom: 4,
      });
    } catch (error) {
      console.error(error);
    }
  },

  methods: {
    state(param) {
      if (this.submit) {
        return !this.$v.dados[param].$invalid;
      } else {
        return null;
      }
    },
    inputContrato() {
      this.optionProjeto = [];
      this.optionCooperado = [];
      this.dados.projeto = null;
      this.dados.cooperado = null;
      this.dados.matriz = this.dados.contrato.matriz;
      this.optionProjeto = this.$tools.filtroTomador.selectProjetos(this.$store.state.filtroTomador, 
                                                                    this.dados.contrato.numero);
    },
    inputProjeto() {
      this.optionCooperado = [];
      this.dados.cooperado = null;
      this.optionCooperado = this.$tools.filtroTomador.selectCooperados(this.$store.state.filtroTomador, 
                                                                        this.dados.projeto.numero);
    },
    filtrar() {
      this.submit = true;
      this.$v.$touch();
      if(this.$v.$invalid) {
        return
      }
      this.viewVeiculos = false;
      this.viewTabela = false;
      this.loading = true;
      var cooperado = "";
      if (this.dados.cooperado) {
        cooperado = this.dados.cooperado.numero;
      } else {
        this.optionCooperado.forEach((el) => {
          cooperado += el.numero + ",";
        });
        cooperado = cooperado.substr(0, cooperado.length - 1);
      }
      this.$http.post("api/telemetria", {
          referenciaInicio: this.dados.referencia[0],
          referenciaFim: this.dados.referencia[1],
          cooperado: cooperado,
          cd_projeto: this.dados.projeto.numero,
        })
        .then((response) => {
          this.dadosGps = response.data;
          if(this.dadosGps.length > 0){
            this.dashboardInit();
            this.$tools.fecharMenu();
          }else{
            this.$tools.alerta("Nenhuma informação encontrada com esses parametros", "error");
            this.loading = false;
          }
        }).catch((err) => {
          console.log(err);
          this.$tools.alerta("Nenhuma informação encontrada com esses parametros", "error");
        });
    },
    dashboardInit() {
      var placas = [];
      var cooperados = [];
      this.dashboard = this.atribuiDashboard();
      this.mapaCalendario = new Date(this.dadosGps[0].dt_gps);
      this.dadosGps.forEach((el) => {
        if (!placas.includes(el.nr_placa)) {
          placas.push(el.nr_placa);
          this.dashboard.placa.quantidade += 1;
          this.dashboard.placa.dados.push(this.objCooperado(el));
        }
        if (!cooperados.includes(el.cd_pessoa)) {
          cooperados.push(el.cd_pessoa);
          this.dashboard.cooperados.quantidade += 1;
          this.dashboard.cooperados.dados.push(this.objCooperado(el));
        }
        if (parseInt(el.nr_velocidade) > parseInt(this.dashboard.maiorVelocidade.quantidade)) {
          this.dashboard.maiorVelocidade.quantidade = el.nr_velocidade;
          this.dashboard.maiorVelocidade.dados[0] = this.objCooperadoAux(el);
        }
        switch (el.tp_posicao) {
          case "E":
            if(!this.dashboard.excessoVelocidade.cooperado.includes(el.cd_pessoa)){
              this.dashboard.excessoVelocidade.cooperado.push(el.cd_pessoa);
            } 
            this.dashboard.excessoVelocidade.quantidade += 1;
            this.dashboard.excessoVelocidade.dados.push(this.objCooperadoAux(el));
            break;
          case "F":
            if(!this.dashboard.foraHorario.cooperado.includes(el.cd_pessoa)){
              this.dashboard.foraHorario.cooperado.push(el.cd_pessoa);
            } 
            this.dashboard.foraHorario.quantidade += 1;
            this.dashboard.foraHorario.dados.push(this.objCooperadoAux(el));

            break;
          case "M":
            if(!this.dashboard.madrugada.cooperado.includes(el.cd_pessoa)){
              this.dashboard.madrugada.cooperado.push(el.cd_pessoa);
            } 
            this.dashboard.madrugada.quantidade += 1;
            this.dashboard.madrugada.dados.push(this.objCooperadoAux(el));
            break;
          case "R":
            if(!this.dashboard.risco.cooperado.includes(el.cd_pessoa)){
              this.dashboard.risco.cooperado.push(el.cd_pessoa);
            } 
            this.dashboard.risco.quantidade += 1;
            this.dashboard.risco.dados.push(this.objCooperadoAux(el));
            break;
        }
      });
      this.viewVeiculos = true;
      this.loading = false;
      this.montarMapaCalor(this.mapaCalendario);
    },
    objCooperado(coop) {
      return {
        placa: coop.nr_placa,
        cooperado: coop.ge_pessoa.nm_razao,
        cd_cooperado: coop.ge_pessoa.cd_pessoa,
        detalhes:coop.cd_pessoa
      };
    },
    objCooperadoAux(coop) {
      return {
        placa: coop.nr_placa,
        cooperado: coop.ge_pessoa.nm_razao,
        velocidade: coop.nr_velocidade+"km/h",
        horario: coop.data+" "+coop.hora,
        detalhes:coop.cd_pessoa
      };
    },
    trataData(param){
      if(param == "avanca"){
        this.mapaCalendario.setDate(this.mapaCalendario.getDate() + 1);
      }else{
        this.mapaCalendario.setDate(this.mapaCalendario.getDate() - 1);
      }
      this.mapaCalendario = new Date(this.mapaCalendario);
      this.montarMapaCalor(this.mapaCalendario);
    },
    montarMapaCalor(param) {
      var dataFormat = param.toLocaleDateString()
      var pontos = [];
      if (this.heatmap) {
        this.heatmap.setMap(null);
      }

      this.dadosGps.forEach((el) => {
        if (dataFormat == el.data || dataFormat == "Todos") {
          pontos.push(
            new this.google.maps.LatLng(
              parseFloat(el.nr_latitude),
              parseFloat(el.nr_longitude)
            )
          );
        }
      });

      if(pontos.length == 0){
        alert("Não tem ocorrencias esse dia");
        return;
      }

      this.heatmap = new this.google.maps.visualization.HeatmapLayer({
        data: pontos,
        map: this.map,
      });

      this.heatmap.set("radius", 20);
      this.heatmap.setMap(this.map);

      this.map.setCenter(pontos[0]);
    },
    fundoBotao(param) {
      if (param == this.acao) {
        return "fundoAcao";
      } else {
        return "";
      }
    },
    tableAcoes(acao) {
      this.acao = acao;
      this.itemsTable = this.dashboard[acao].dados;
      this.rows = this.itemsTable.length;
      this.viewTabela = true;
    },
    atribuiDashboard(){
      return {
        placa: {
          quantidade: 0,
          dados: [],
        },
        cooperados: {
          quantidade: 0,
          dados: [],
        },
        naoRastreados: {},
        maiorVelocidade: {
          quantidade: 0,
          dados: [],
        },
        excessoVelocidade: {
          cooperado:[],
          quantidade: 0,
          dados: [],
        },
        foraHorario: {
          cooperado:[],
          quantidade: 0,
          dados: [],
        },
        madrugada: {
          cooperado:[],
          quantidade: 0,
          dados: [],
        },
        risco: {
          cooperado:[],
          quantidade: 0,
          dados: [],
        },
      }
    },
    detalhes(dadosTabela){
      var filtro = {
        referenciaInicio:this.dados.referencia[0],
        referenciaFim:this.dados.referencia[1],
        contrato:this.dados.contrato,
        projeto:this.dados.projeto,
        cooperado:{nome:dadosTabela.cooperado, numero:dadosTabela.detalhes}
      }
      this.$store.commit('FILTRO_TELEMETRIA', filtro);
      this.$router.push('/tomadora/telemetria/acompanhamento');
    },
    limparFormulario(){
      this.dados.referencia = null;
      this.dados.contrato = null;
      this.dados.matriz = null;
      this.dados.projeto = null;
      this.dados.cooperado = null;
    },
  },
};
</script>
<style>
.responsive {
  width: 100%;
  height: auto;
}
.div-clickable {
  cursor: pointer;
}
.fundoAcao {
  background-color: gainsboro;
}
</style>